"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCompanies = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_1 = require("@ivanlog/gs");
const StateComany_1 = require("./StateComany");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateCompanies extends StatePaged_1.StatePaged {
    static SelectCompany() {
        return new Promise((resolve, reject) => {
            gs_1.StateGS.Run(StateCompanies, { callbackOnSelect: resolve });
        });
    }
    constructor() {
        super(com.PageList, "Companies", true);
        this._includeDeleted = false;
        this._callbackOnSelect = null;
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateComany_1.StateCompany);
        this._setupFilters();
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.CompanyControl))
            this.page.ctrls.btnNew.hide();
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (arg) {
                this._callbackOnSelect = arg.callbackOnSelect;
                if (this._callbackOnSelect)
                    this.title = "Select company:";
            }
            const companies = yield this.lockgui(this.app.api.admin.directory.getCompanies(this._includeDeleted));
            if (!companies)
                return gs_1.StateRunResultEnum.Failed;
            this.fill(companies);
            return _super.start.call(this);
        });
    }
    fill(companies) {
        this.page.ctrls.list.html = "";
        for (const company of companies) {
            const item = new com.ListItem();
            item.ctrls.lType.text = company.isDeleted
                ? "Company (deleted)"
                : "Company";
            item.ctrls.lId.text = `#${company.id}`;
            let data = [
                gs.text.clearHtmlToText(`${company.shortName}`),
                gs.text.clearHtmlToText(`Full: ${company.name}`),
            ];
            item.ctrls.pData.html = data.join("<br>");
            this.page.ctrls.list.append(item);
            if (this._callbackOnSelect)
                item.onclick = () => this._callbackOnSelect(company);
            else if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.CompanyControl))
                item.onclick = () => gs_1.StateGS.Run(StateComany_1.StateCompany, company);
            else
                item.onclick = () => new modalCom.DialogOk(gs.helpers.text.replaceAll(company.companyData, "\n", "<br>"), "Company information").show();
        }
    }
    _setupFilters() {
        this.page.ctrls.blockFilters.show();
        if (this.page.ctrls.labelFilter)
            this.page.ctrls.labelFilter.text = "Show";
        const select = this._getFilterElement();
        if (!select)
            return;
        select.innerHTML = "";
        select.append(new Option("Active only", "active"));
        select.append(new Option("All companies", "all"));
        select.value = this._includeDeleted ? "all" : "active";
        select.onchange = () => __awaiter(this, void 0, void 0, function* () {
            this._includeDeleted = select.value === "all";
            const companies = yield this.lockgui(this.app.api.admin.directory.getCompanies(this._includeDeleted));
            if (companies)
                this.fill(companies);
        });
    }
    _getFilterElement() {
        var _a;
        const element = (_a = this.page.ctrls.selectFilter) === null || _a === void 0 ? void 0 : _a.el;
        return element instanceof HTMLSelectElement ? element : null;
    }
}
exports.StateCompanies = StateCompanies;
StateCompanies.StateName = "companies";
//# sourceMappingURL=StateCompanies.js.map